/**
 * socialService — publicación en redes desde Studio Media Labs.
 *
 * El frontend NUNCA habla con Buffer: sólo con /api/social/*. Ningún
 * token del proveedor llega acá.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/social`;

export const socialService = {
  async status() {
    const res = await axios.get(`${API}/status`);
    return res.data;
  },

  async connect(redirectAfter) {
    const res = await axios.post(`${API}/connect`, { redirect_after: redirectAfter });
    return res.data;
  },

  async syncChannels() {
    const res = await axios.post(`${API}/channels/sync`);
    return res.data;
  },

  async disconnect() {
    const res = await axios.post(`${API}/disconnect`);
    return res.data;
  },

  async validate(payload) {
    const res = await axios.post(`${API}/validate`, payload);
    return res.data;
  },

  async publish(payload) {
    const res = await axios.post(`${API}/publish`, payload);
    return res.data;
  },

  async listPosts(limit = 50) {
    const res = await axios.get(`${API}/posts?limit=${limit}`);
    return res.data;
  },

  async refreshPost(postId) {
    const res = await axios.post(`${API}/posts/${postId}/refresh`);
    return res.data;
  },

  async cancelPost(postId) {
    const res = await axios.post(`${API}/posts/${postId}/cancel`);
    return res.data;
  },
};

export default socialService;
